module.exports = __webpack_public_path__ + "assets/img/download-btn-24475fb2.png";